"use strict";
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const locateCoordinates = (coords) => __async(void 0, null, function* () {
  const result = yield new Promise((resolve, reject) => {
    $.post(
      "/locate",
      {
        latitude: coords.latitude,
        longitude: coords.longitude
      },
      (data) => {
        resolve(data);
      },
      "json"
    );
  });
  return (result == null ? void 0 : result.address) || null;
});
export default locateCoordinates;
